import moduleCommon from "@/store/common/moduleCommon.js";
import Api from "@/helpers/api.js";
import {Validator} from "vee-validate";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import PopupMap from "@/components/optimization/visit-point/PopupMap.vue";
import {MapFeatures} from "@/plugins/mapFeatures";
import ManageErrorMessages from "@/models/ManageErrorMessages";
import phonesSuccess from "@/assets/images/markers/phones_success.png";
import {en, es} from "vuejs-datepicker/src/locale";
import Datepicker from "vuejs-datepicker";
import DateUtils from "@/helpers/DateUtils.js";
import Utils from "@/helpers/Utils";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleMap from "@/store/map/moduleMap.js";
import SelectVehicle from "@/components/optimization/resource/SelectVehicle.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";
import moment from "moment";

export const visitPointCreateMixin = {
	name: "VisitPointCreate",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		Datepicker,
		PopupMap,
		VuePerfectScrollbar,
		SelectVehicle,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
		activeTabProp: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			latAndLng: "",
			popupMapMounted: false,
			dataCity: null,
			selectedCountry: null,
			selectedDepartment: null,
			departments: [],
			countries: [],
			cities: [],
			showButtonAddCoordinates: true,
			dataGeo: {},
			activeTab: 0,
			hours: 0,
			minutes: 0,
			priority: 0,
			showPromptField: false,
			showPromptDemand: false,
			showPromptTimeWindow: false,
			showPromptSkill: false,
			propertiesList: [],
			propertiesListDemand: [],
			propertiesListTimeWindow: [],
			propertiesListSkill: [],
			propertiesObject: {},
			isUpdate: false,
			isUpdateDemand: false,
			isUpdateTimeWindow: false,
			isUpdateSkill: false,
			indexUpdate: null,
			indexUpdateDemand: null,
			indexUpdateTimeWindow: null,
			indexUpdateSkill: null,
			showGeoAgaing: false,
			isDisabled: true,
			marker: null,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			geoAlert: false,
			geoAlertAddress: false,
			langHe: es,
			langEn: en,
			checkboxPickup: false,
			checkboxDelivery: false,
			isDisabledPickup: false,
			isDisabledDelivery: false,
			propertySkill: "",
			showPromptPermittedVehicle: false,
			isUpdatePermittedVehicle: false,
			propertiesListPermittedVehicle: [],
			indexUpdatePermittedVehicle: null,
			propertyPermittedVehicle: "",
			isSoftTimeWindow: false,
			isAlertTimeWindow: false,
			validFormTimeWindowComputed: true,
			closeInfo: true,
			renderComponentTimeWindow: 0,
			visitPoint: {
				identification: "",
				original_identification: "",
				priority: 0,
				territory_id: "",
			},
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			property: {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			},
			type: [
				{
					label: "Text",
					value: "text",
				},
				{
					label: "Date",
					value: "date",
				},
				{
					label: "Time",
					value: "time",
				},
				{
					label: "Number",
					value: "number",
				},
			],
			mapConfig: {
				name: "popup-map",
				latitude: 4.686699,
				longitude: -74.0837187,
				zoom: "13",
				theme: "uber",
				calledFrom: "DinamicFields",
			},
			formatData: {
				country: "",
				department: "",
				city: "",
				address: "",
				addressOld: "",
				cx: 0,
				cy: 0,
			},
			propertyDemand: {
				name: "",
				amount: "",
			},
			propertyTimeWindow: {
				init_date_window: "",
				end_date_window: "",
				init_hour_window: "",
				end_hour_window: "",
			},
			baseTimeWindow: {
				init_date_window: "",
				end_date_window: "",
				init_hour_window: "",
				end_hour_window: "",
			},
		};
	},
	computed: {
		countriesOptions() {
			return this.generateOptionSelect(this.$store.state.moduleCommon.countries, "country_name", "country_name");
		},
		validateForm() {
			return !this.errors.any();
		},
		vsPopupTitle() {
			return `${this.$t("Select")} ${this.$t("Routing.Point")}`;
		},
		disabledDatesTo() {
			return {to: new Date(this.propertiesListTimeWindow.init_date_window)};
		},
		getDateWithoutTime() {
			return (date) => {
				return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
			};
		},
		showErrorSoftWindow() {
			return (generalWindow, fieldTimeWindow, fieldSoftWindow) => {
				const softTimeDate = new Date(generalWindow.soft_time_window[fieldSoftWindow]);
				const generalDate = new Date(generalWindow[fieldTimeWindow]);
				return softTimeDate != "" && fieldTimeWindow === "init_date_window"
					? this.getDateWithoutTime(softTimeDate) < this.getDateWithoutTime(generalDate)
					: this.getDateWithoutTime(softTimeDate) > this.getDateWithoutTime(generalDate);
			};
		},
		showErrorSoftWindowHour() {
			return (generalWindow, fieldGeneralWindow, fieldSoftWindow) => {
				const softTimeDate = generalWindow.soft_time_window[fieldSoftWindow];
				const generalDate = generalWindow[fieldGeneralWindow];
				return (
					softTimeDate !== "" &&
					(fieldGeneralWindow === "init_hour_window"
						? this.stringTimeToDate(softTimeDate) < this.stringTimeToDate(generalDate)
						: this.stringTimeToDate(softTimeDate) > this.stringTimeToDate(generalDate))
				);
			};
		},
		isStartBeforeEnd() {
			return (generalWindow, fieldInit, fieldEnd) => {
				const softTimeDateInit =
					fieldInit === "init_hour"
						? generalWindow.soft_time_window[fieldInit]
						: this.getDateWithoutTime(new Date(generalWindow.soft_time_window[fieldInit]));
				const softTimeDateEnd =
					fieldInit === "init_hour"
						? generalWindow.soft_time_window[fieldEnd]
						: this.getDateWithoutTime(new Date(generalWindow.soft_time_window[fieldEnd]));
				return fieldInit === "init_hour"
					? this.stringTimeToDate(softTimeDateInit) > this.stringTimeToDate(softTimeDateEnd)
					: softTimeDateInit > softTimeDateEnd;
			};
		},
		validFormAdditionalFields() {
			return this.property.label.length > 0 && this.property.value.length > 0;
		},
		validFormDemand() {
			return this.propertyDemand.name.length > 0 && this.propertyDemand.amount.length > 0;
		},
		validFormTimeWindow: {
			get() {
				this.validFormTimeWindowComputed =
					this.propertyTimeWindow.init_date_window !== "" &&
					this.propertyTimeWindow.end_date_window !== "" &&
					this.propertyTimeWindow.init_hour_window !== "" &&
					this.propertyTimeWindow.end_hour_window !== "" &&
					Date.parse(this.propertyTimeWindow.end_date_window) -
						Date.parse(this.propertyTimeWindow.init_date_window) >=
						0 &&
					!this.errors.has("dataHourInit") &&
					!this.errors.has("dataHourEnd");
				return this.propertyTimeWindow.hasOwnProperty("soft_time_window")
					? this.validFormTimeWindowComputed && this.validFormSoftTimeWindow
					: this.validFormTimeWindowComputed;
			},
			set(val) {
				this.validFormTimeWindowComputed = val;
				return this.validFormTimeWindowComputed;
			},
		},
		validFormSoftTimeWindow() {
			return (
				this.propertyTimeWindow.soft_time_window.init_date !== "" &&
				this.propertyTimeWindow.soft_time_window.end_date !== "" &&
				this.propertyTimeWindow.soft_time_window.init_hour !== "" &&
				this.propertyTimeWindow.soft_time_window.end_hour !== "" &&
				!this.isStartBeforeEnd(this.propertyTimeWindow, "init_date", "end_date") &&
				!this.showErrorSoftWindow(this.propertyTimeWindow, "init_date_window", "init_date") &&
				!this.showErrorSoftWindow(this.propertyTimeWindow, "end_date_window", "end_date") &&
				!this.isStartBeforeEnd(this.propertyTimeWindow, "init_hour", "end_hour") &&
				!this.showErrorSoftWindowHour(this.propertyTimeWindow, "init_hour_window", "init_hour") &&
				!this.showErrorSoftWindowHour(this.propertyTimeWindow, "end_hour_window", "end_hour")
			);
		},
		validFormSkill() {
			return this.propertySkill.length > 0;
		},
		validFormPermittedVehicle() {
			return this.propertyPermittedVehicle.length > 0;
		},
		vehicleList() {
			return this.$store.state.moduleOptimization.standardInputList["vehicles"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["vehicles"];
		},
		optimizersList() {
			return this.$store.state.moduleOptimization.listCompanyOptimizers;
		},
		getTerritoriesIdsUnicos() {
			return (vehicles) => {
				const territoriesIds = vehicles.flatMap((vehicle) =>
					vehicle.territories && vehicle.territories.items
						? vehicle.territories.items.map((territory) => territory.id)
						: []
				);
				return [...new Set(territoriesIds)];
			};
		},
	},
	mounted() {
		if (this.activeTabProp === 0) {
			this.checkboxPickup = true;
			this.checkboxDelivery = false;
			this.isDisabledDelivery = false;
			this.isDisabledPickup = true;
		} else {
			this.checkboxDelivery = true;
			this.checkboxPickup = false;
			this.isDisabledPickup = false;
			this.isDisabledDelivery = true;
		}
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		geoCoder() {
			const {country, city, address, department} = this.formatData;
			if (address === null || address === undefined || address === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPoints.MissingAddress.Title"),
					text: this.$t("VisitPoints.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					this.closeLoading();
					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}
					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.Georeferencer"),
							text: this.$t("VisitPoints.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}

					if (res.status === 200) {
						this.dataGeo = {...res.data};
						this.formatData.cy = parseFloat(this.dataGeo.latitude);
						this.formatData.cx = parseFloat(this.dataGeo.longitude);
						this.formatData.cy.toFixed(8);
						this.formatData.cx.toFixed(8);
						this.geoAlertAddress = false;
						this.showButtonAddCoordinates = true;
						if (this.dataGeo.latitude !== "0" || this.dataGeo.longitude !== "0") {
							this.$vs.notify({
								color: "success",
								title: this.$t("VisitPoints.FindAddress.Title"),
								text: this.$t("VisitPoints.FindAddress.Text"),
							});
							this.showGeoAgaing = true;
							this.map.removeMarker(this.marker);
							this.marker = this.map.addMarkerToMap(this.formatData, {
								icon: phonesSuccess,
								draggable: true,
								infoWindow: {
									content: `
										<div class='flex items-center mt-2'>
											<span class='text-ms'>${formatData.cy}, ${formatData.cx}</span>
										</div>
									`,
								},
								onDragend: (coords) => {
									this.geoReverse({
										cy: coords.lat,
										cx: coords.lng,
									});
								},
							});
							this.isDisabled = true;
						} else {
							this.$vs.notify({
								color: "warning",
								title: this.$t("VisitPoints.ErrorFindAddress.Title"),
								text: this.$t("VisitPoints.ErrorFindAddress.Text"),
							});
						}
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		geoReverse({cy, cx}) {
			this.openLoading();
			this.isDisabled = true;
			this.$store
				.dispatch("moduleMap/geoinverso", {cy, cx})
				.then((res) => {
					this.closeLoading();
					if (res.data.address1 !== this.formatData.address) {
						this.formatData.cy = cy.toFixed(8);
						this.formatData.cx = cx.toFixed(8);
						this.formatData.address = res.data.address1;
						this.formatData.addressOld = res.data.address1;
						this.selectedCountry = res.data.country_long_name;
						this.selectedDepartment = res.data.department1;
						this.dataCity = res.data.city1;
						this.showButtonAddCoordinates = true;
						this.geoAlertAddress = false;
					}
					if (res.status === 200 && (res.data.status === "C" || res.data.status === "")) {
						this.formatData.cy = 0;
						this.formatData.cx = 0;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPoints.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPoints.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		getInstanceMap(data) {
			const map = data.map;
			this.marker = data.marker;
			this.map = new MapFeatures(map);
		},
		cancelAction() {
			this.formatData.address = this.formatData.addressOld;
			this.showButtonAddCoordinates = true;
			this.isDisabled = true;
			this.geoAlertAddress = false;
		},
		generateOptionSelect(data, propLabel, propValue) {
			if (!Array.isArray(data)) {
				return [];
			}
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		async addVisitPoint() {
			this.$vs.loading();
			const validationResult = await this.$validator.validateAll("create-visit-point");
			if (!validationResult) {
				this.handleValidationError();
				return;
			}
			this.processTimeWindowProperties();
			const coordinates = this.parseCoordinates();
			const payload = this.createPayload(coordinates);
			this.cleanUpPayload(payload);
			this.commitToStoreAndEmit(payload);
			this.$emit("addMarkerEmit", payload);
			this.$vs.loading.close();
			this.closeSidebarAddVisitPoint();
		},
		handleValidationError() {
			this.$vs.notify({
				color: "warning",
				title: this.$t("ErrorFields.Title"),
				text: this.$t("ErrorFields.Text"),
			});
			this.$vs.loading.close();
		},
		parseCoordinates() {
			const [lat, lng] = this.latAndLng.split(",");
			return {lat, lng};
		},
		processTimeWindowProperties() {
			if (this.propertiesListTimeWindow.length > 0) {
				this.propertiesListTimeWindow.forEach((item) => {
					if (item.hasOwnProperty("soft_time_window")) {
						item.soft_time_window.cost_per_hour_before = parseInt(
							item.soft_time_window.cost_per_hour_before,
							10
						);
						item.soft_time_window.cost_per_hour_after = parseInt(
							item.soft_time_window.cost_per_hour_after,
							10
						);
					}
				});
			}
		},
		createPayload(coordinates) {
			return {
				identification: this.visitPoint.identification,
				original_identification: this.visitPoint.original_identification,
				longitude: parseFloat(coordinates.lng),
				latitude: parseFloat(coordinates.lat),
				priority: parseInt(this.visitPoint.priority, 10),
				time_service: `${this.hours < 10 ? "0" + this.hours : this.hours}:${
					this.minutes < 10 ? "0" + this.minutes : this.minutes
				}:00`,
				skills: this.propertiesListSkill,
				allowed_vehicles: this.propertiesListPermittedVehicle,
				demand: this.propertiesListDemand,
				time_window: this.propertiesListTimeWindow,
				additional_info: this.propertiesObject,
				territory_id: this.visitPoint.territory_id,
			};
		},
		cleanUpPayload(payload) {
			const keysToDelete = [
				{key: "skills", condition: payload.skills.length <= 0},
				{key: "allowed_vehicles", condition: payload.allowed_vehicles.length <= 0},
				{key: "time_window", condition: payload.time_window.length <= 0},
				{key: "demand", condition: payload.demand.length <= 0},
				{
					key: "additional_info",
					condition:
						Object.keys(payload.additional_info).length <= 0 &&
						payload.additional_info.constructor === Object,
				},
				{
					key: "priority",
					condition: payload.priority == "" || payload.priority === null || payload.priority === undefined,
				},
				{
					key: "time_service",
					condition:
						payload.time_service === "" ||
						payload.time_service === null ||
						payload.time_service === undefined,
				},
				{
					key: "original_identification",
					condition:
						payload.original_identification === "" ||
						payload.original_identification === null ||
						payload.original_identification === undefined,
				},
				{
					key: "territory_id",
					condition:
						payload.territory_id === "" ||
						payload.territory_id === null ||
						payload.territory_id === undefined,
				},
			];
			keysToDelete.forEach((item) => {
				if (item.condition) {
					delete payload[item.key];
				}
			});
		},
		commitToStoreAndEmit(payload) {
			if (this.checkboxPickup) {
				this.$store.commit("moduleOptimization/SET_VISIT_POINT_STANDARD_INPUT_PICKUP", [payload]);
			}
			if (this.checkboxDelivery) {
				this.$store.commit("moduleOptimization/SET_VISIT_POINT_STANDARD_INPUT_DELIVERY", [payload]);
			}
		},
		validateErrorRegister(error) {
			if (error.data === null || error.data === undefined) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: this.$t("VisitPoints.ErrorRegisterValidate.Text"),
				});
				return;
			}
			if (error.data.reason.length > 0) {
				let reason = Array.from(new Set(error.data.reason.flatMap(({absolute_path}) => absolute_path)));
				let reasonFiltered = reason
					.filter((m) => m !== "additional_info")
					.map((m) => `${m.toUpperCase()}: ${this.$t("Routing.Messages.ValidatorRequiredProperty")} `)
					.join("; ");
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: reasonFiltered,
					time: 6000,
				});
			}
		},
		getCities(departmentName) {
			Api.post("/divipola", {
				country:
					typeof this.selectedCountry === "object" ? this.selectedCountry.value : this.selectedCountry.label,
				department: departmentName ? departmentName.replaceAll(",", "") : "",
				city: "",
				world_code: "",
				only: "city_name",
				fields: ["city_name"],
			})
				.then((res) => {
					this.cities = this.generateOptionSelect(res.data, "city_name", "city_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Cities", e);
				});
		},
		getDepartments(countryName) {
			Api.post("/divipola", {
				country: countryName,
				department: "",
				city: "",
				world_code: "",
				only: "department_name",
				fields: ["department_name"],
			})
				.then((res) => {
					this.departments = this.generateOptionSelect(res.data, "department_name", "department_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Department name", e);
				});
		},
		addProperty(property) {
			let findOther = this.propertiesList.findIndex((elem) => elem.label === property.label);
			if (findOther == -1) {
				this.propertiesList.push(property);
				this.propertiesObject[property.label] = property.value;
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdate) {
				this.updateProperty(property);
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		addPropertyDemand(propertyDemand) {
			propertyDemand = {
				name: propertyDemand.name,
				amount: parseInt(propertyDemand.amount),
			};
			let findOther = this.propertiesListDemand.findIndex((elem) => elem.name === propertyDemand.name);
			if (findOther == -1) {
				this.propertiesListDemand.push(propertyDemand);
				this.propertyDemand = {
					name: "",
					amount: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdateDemand) {
				this.updatePropertyDemand(propertyDemand);
				this.propertyDemand = {
					name: "",
					amount: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		deleteItem(data, indexItem) {
			this.propertiesList.splice(indexItem, 1);
			delete this.propertiesObject[data.label];
		},
		editSelect(val, index) {
			this.isUpdate = true;
			this.showPromptField = true;
			this.property.label = val.label;
			this.property.value = val.value;
			this.property.type = val.type;
			this.indexUpdate = index;
		},
		updateProperty(property) {
			this.propertiesList[this.indexUpdate].label = property.label;
			this.propertiesList[this.indexUpdate].value = property.value;
			this.propertiesList[this.indexUpdate].type = property.type;
			this.propertiesObject[property.label] = property.value;
		},
		deleteItemDemand(data, indexItem) {
			this.propertiesListDemand.splice(indexItem, 1);
		},
		editSelectDemand(val, index) {
			this.isUpdateDemand = true;
			this.showPromptDemand = true;
			this.propertyDemand.name = val.name;
			this.propertyDemand.amount = val.amount;
			this.indexUpdateDemand = index;
		},
		updatePropertyDemand(propertyDemand) {
			this.propertiesListDemand[this.indexUpdateDemand].name = propertyDemand.name;
			this.propertiesListDemand[this.indexUpdateDemand].amount = propertyDemand.amount;
		},
		showPrompt() {
			this.showPromptField = true;
			this.isUpdate = false;
			this.property = {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			};
		},
		showPromptDemands() {
			this.showPromptDemand = true;
			this.isUpdateDemand = false;
			this.propertyDemand = {
				name: "",
				amount: "",
			};
		},
		showPromptTimeWindows() {
			if (this.propertiesListTimeWindow.length > 0) {
				if (!this.propertiesListTimeWindow[0].hasOwnProperty("soft_time_window")) {
					this.showPromptForNewTimeWindow();
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("TimeWindow.CreateTimeWindows"),
						text: this.$t("TimeWindow.ItIsNotPossibleToAddAnotherTimeWindow"),
						time: 8000,
					});
				}
			} else {
				this.showPromptForNewTimeWindow();
			}
		},
		showPromptForNewTimeWindow() {
			this.showPromptTimeWindow = true;
			this.isUpdateTimeWindow = false;
			this.deleteSoftWindow();
			this.setTimeWindowProperties();
		},
		editSelectTimeWindow(val, index) {
			this.propertyTimeWindow.init_date_window = moment(val.init_date_window).format();
			this.propertyTimeWindow.end_date_window = moment(val.end_date_window).format();
			this.propertyTimeWindow.init_hour_window = val.init_hour_window;
			this.propertyTimeWindow.end_hour_window = val.end_hour_window;
			if (val.hasOwnProperty("soft_time_window")) {
				this.addSoftWindowToTimeWindow();
				this.propertyTimeWindow.soft_time_window.init_date = moment(val.soft_time_window.init_date).format();
				this.propertyTimeWindow.soft_time_window.end_date = moment(val.soft_time_window.end_date).format();
				this.propertyTimeWindow.soft_time_window.init_hour = val.soft_time_window.init_hour;
				this.propertyTimeWindow.soft_time_window.end_hour = val.soft_time_window.end_hour;
				this.propertyTimeWindow.soft_time_window.cost_per_hour_before =
					val.soft_time_window.cost_per_hour_before;
				this.propertyTimeWindow.soft_time_window.cost_per_hour_after = val.soft_time_window.cost_per_hour_after;
			} else {
				this.isSoftTimeWindow = false;
			}
			this.isUpdateTimeWindow = true;
			this.showPromptTimeWindow = true;
			this.indexUpdateTimeWindow = index;
		},
		updatePropertyTimeWindow(propertyTimeWindow) {
			this.propertiesListTimeWindow[this.indexUpdateTimeWindow].init_date_window =
				propertyTimeWindow.init_date_window;
			this.propertiesListTimeWindow[this.indexUpdateTimeWindow].end_date_window =
				propertyTimeWindow.end_date_window;
			this.propertiesListTimeWindow[this.indexUpdateTimeWindow].init_hour_window =
				propertyTimeWindow.init_hour_window;
			this.propertiesListTimeWindow[this.indexUpdateTimeWindow].end_hour_window =
				propertyTimeWindow.end_hour_window;
			if (propertyTimeWindow.hasOwnProperty("soft_time_window")) {
				this.propertiesListTimeWindow[this.indexUpdateTimeWindow].soft_time_window.init_date =
					propertyTimeWindow.soft_time_window.init_date;
				this.propertiesListTimeWindow[this.indexUpdateTimeWindow].soft_time_window.end_date =
					propertyTimeWindow.soft_time_window.end_date;
				this.propertiesListTimeWindow[this.indexUpdateTimeWindow].soft_time_window.init_hour =
					propertyTimeWindow.soft_time_window.init_hour;
				this.propertiesListTimeWindow[this.indexUpdateTimeWindow].soft_time_window.end_hour =
					propertyTimeWindow.soft_time_window.end_hour;
				this.propertiesListTimeWindow[this.indexUpdateTimeWindow].soft_time_window.cost_per_hour_before =
					propertyTimeWindow.soft_time_window.cost_per_hour_before;
				this.propertiesListTimeWindow[this.indexUpdateTimeWindow].soft_time_window.cost_per_hour_after =
					propertyTimeWindow.soft_time_window.cost_per_hour_after;
			}
		},
		deleteItemTimeWindow(indexItem) {
			this.isSoftTimeWindow = false;
			this.propertiesListTimeWindow.splice(indexItem, 1);
			this.renderComponentTimeWindow++;
		},
		async addPropertyTimeWindow(propertyTimeWindow) {
			propertyTimeWindow.init_date_window = DateUtils.toDefaultDateTime(
				propertyTimeWindow.init_date_window,
				"YYYY-MM-DD"
			);
			propertyTimeWindow.end_date_window = DateUtils.toDefaultDateTime(
				propertyTimeWindow.end_date_window,
				"YYYY-MM-DD"
			);
			if (propertyTimeWindow.hasOwnProperty("soft_time_window")) {
				propertyTimeWindow.soft_time_window.init_date = DateUtils.toDefaultDateTime(
					propertyTimeWindow.soft_time_window.init_date,
					"YYYY-MM-DD"
				);
				propertyTimeWindow.soft_time_window.end_date = DateUtils.toDefaultDateTime(
					propertyTimeWindow.soft_time_window.end_date,
					"YYYY-MM-DD"
				);
			}
			let findOther = this.propertiesListTimeWindow.findIndex(
				(elem) =>
					elem.init_date_window === propertyTimeWindow.init_date_window &&
					elem.end_date_window === propertyTimeWindow.end_date_window &&
					elem.init_hour_window === propertyTimeWindow.init_hour_window &&
					elem.end_hour_window === propertyTimeWindow.end_hour_window
			);
			if (this.isUpdateTimeWindow) {
				this.updatePropertyTimeWindow(propertyTimeWindow);
				this.setTimeWindowProperties();
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (findOther == -1) {
				await this.propertiesListTimeWindow.push(propertyTimeWindow);
				this.setTimeWindowProperties();
				setTimeout(() => {
					this.errors.clear();
				}, 60);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
			this.$validator.pause();
			this.$nextTick(() => {
				this.$validator.errors.clear();
				this.$validator.fields.items.forEach((field) => field.reset());
				this.$validator.fields.items.forEach((field) => this.errors.remove(field));
				this.$validator.resume();
			});
		},
		showPromptSkills() {
			this.showPromptSkill = true;
			this.isUpdateSkill = false;
			this.propertySkill = "";
		},
		updatePropertySkill(propertySkill) {
			this.propertiesListSkill[this.indexUpdateSkill] = propertySkill;
		},
		deleteItemSkill(indexItem) {
			this.propertiesListSkill.splice(indexItem, 1);
		},
		addPropertySkill(propertySkill) {
			let findOther = this.propertiesListSkill.findIndex((elem) => elem === propertySkill);
			if (this.isUpdateSkill) {
				this.updatePropertySkill(propertySkill);
				this.propertySkill = "";
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (findOther == -1) {
				this.propertiesListSkill.push(propertySkill);
				this.propertySkill = "";
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		showPromptPermittedVehicles() {
			this.showPromptPermittedVehicle = true;
			this.isUpdatePermittedVehicle = false;
			this.propertyPermittedVehicle = "";
		},
		updatePropertyPermittedVehicles(propertyPermittedVehicle) {
			this.propertiesListPermittedVehicle[this.indexUpdatePermittedVehicle] = propertyPermittedVehicle;
		},
		deleteItemPermittedVehicle(indexItem) {
			this.propertiesListPermittedVehicle.splice(indexItem, 1);
		},
		addPropertyPermittedVehicle(propertyPermittedVehicle) {
			let findOther = this.propertiesListPermittedVehicle.findIndex((elem) => elem === propertyPermittedVehicle);
			if (this.isUpdatePermittedVehicle) {
				this.updatepropertyPermittedVehicle(propertyPermittedVehicle);
				this.propertyPermittedVehicle = "";
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (findOther == -1) {
				this.propertiesListPermittedVehicle.push(propertyPermittedVehicle);
				this.propertyPermittedVehicle = "";
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		validateKeyAdditionalInfo(event) {
			let regex = /^[a-zA-Z_]\w*$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateAmountNumber(event) {
			let regex = /^\d+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumber(event) {
			if (this.hours.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberPriority(event) {
			if (this.hours.length === 3) {
				event.preventDefault();
				return false;
			}
		},
		openMap() {
			if (this.latAndLng !== undefined && this.latAndLng !== null && this.latAndLng !== "") {
				const divideCoordinates = this.latAndLng.split(",");
				const coordinates = {
					lat: divideCoordinates[0],
					lng: divideCoordinates[1],
				};
				this.mapConfig.latitude = parseFloat(coordinates.lat);
				this.mapConfig.longitude = parseFloat(coordinates.lng);
				this.showGeoAgain = false;
			}
			this.isDisabled = true;
			this.popupMapMounted = true;
			this.geoAlert = true;
		},
		async callbackClick(markerEvent) {
			this.geoReverse({
				cy: markerEvent.latLng.lat(),
				cx: markerEvent.latLng.lng(),
			});
			this.map.removeMarker(this.marker);
			this.marker = this.map.addMarkerToMap(
				{cy: markerEvent.latLng.lat(), cx: markerEvent.latLng.lng()},
				{
					icon: phonesSuccess,
					draggable: true,
					infoWindow: {
						content: `
							<div class='flex items-center mt-2'>
								<span class='text-ms'>${markerEvent.latLng.lat()}, ${markerEvent.latLng.lng()}</span>
							</div>
						`,
					},
					onDragend: (coords) => {
						this.geoReverse({
							cy: coords.lat,
							cx: coords.lng,
						});
					},
				}
			);
		},
		getCoordinatesDrag(markerEvent) {
			this.geoReverse({
				cy: markerEvent.lat,
				cx: markerEvent.lng,
			});
		},
		confirmCoordinates(data) {
			this.latAndLng = `${(+data.cy).toFixed(8)},${(+data.cx).toFixed(8)}`;
			this.popupMapMounted = false;
		},
		closeSidebarAddVisitPoint() {
			this.$emit("closeSidebarEmit");
		},
		removeError(errorName) {
			const index = this.errors.items.findIndex((e) => e.field === errorName);
			this.errors.items.splice(index, 1);
		},
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		validatorInitDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const ih = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const eh =
				typeof this.propertyTimeWindow.end_date_window === "string"
					? new Date(this.propertyTimeWindow.end_date_window).getTime()
					: this.propertyTimeWindow.end_date_window.getTime();
			return ih <= eh;
		},
		validatorEndDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const eh = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const ih =
				typeof this.propertyTimeWindow.init_date_window === "string"
					? new Date(this.propertyTimeWindow.init_date_window).getTime()
					: this.propertyTimeWindow.init_date_window.getTime();
			return eh >= ih;
		},
		validatorEndHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.propertyTimeWindow.init_hour_window === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.propertyTimeWindow.init_hour_window);
		},
		validatorInitHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.propertyTimeWindow.end_hour_window === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.propertyTimeWindow.end_hour_window);
		},
		addVehicleArray(data) {
			data.forEach((e) => {
				let found = this.propertiesListPermittedVehicle.find((r) => r === e.identification);
				if (!found) {
					this.propertiesListPermittedVehicle.push(e.identification);
				}
			});
		},
		setTimeWindowProperties() {
			if (
				(this.propertiesListTimeWindow.length <= 0 ||
					(this.isUpdateTimeWindow && this.propertiesListTimeWindow.length <= 1)) &&
				this.isSoftTimeWindow
			) {
				this.propertyTimeWindow = {
					...this.baseTimeWindow,
					soft_time_window: {
						init_date: "",
						end_date: "",
						init_hour: "",
						end_hour: "",
						cost_per_hour_before: 0,
						cost_per_hour_after: 0,
					},
				};
			} else {
				this.propertyTimeWindow = {...this.baseTimeWindow};
			}
		},
		deleteSoftWindow() {
			delete this.propertyTimeWindow["soft_time_window"];
			if (this.propertiesListTimeWindow.length > 0) delete this.propertiesListTimeWindow[0]["soft_time_window"];
			this.isSoftTimeWindow = false;
			this.validFormTimeWindowComputed = true;
			this.renderComponentTimeWindow++;
		},
		AddSofTimeWindow() {
			if (!this.validFormTimeWindowComputed) {
				this.isAlertTimeWindow = true;
				this.isSoftTimeWindow = false;
			} else {
				this.addSoftWindowToTimeWindow();
				if (this.propertiesListTimeWindow.length === 1)
					this.propertiesListTimeWindow[0] = this.propertyTimeWindow;
				this.isSoftTimeWindow = true;
				this.isAlertTimeWindow = false;
			}
		},
		addSoftWindowToTimeWindow() {
			this.propertyTimeWindow = {
				...this.propertyTimeWindow,
				soft_time_window: {
					init_date: "",
					end_date: "",
					init_hour: "",
					end_hour: "",
					cost_per_hour_before: 0,
					cost_per_hour_after: 0,
				},
			};
		},
		validatePerCost() {
			if (this.propertyTimeWindow && this.propertyTimeWindow.soft_time_window) {
				Utils.checkZero("cost_per_hour_before", this.propertyTimeWindow.soft_time_window);
				Utils.checkZero("cost_per_hour_after", this.propertyTimeWindow.soft_time_window);
			}
		},
	},
	watch: {
		dataCity(val) {
			if (val) {
				this.formatData.city = typeof val === "object" ? val.value : val;
			}
		},
		selectedCountry(val) {
			if (val === null || val === undefined) {
				return;
			}
			this.formatData.country = typeof val === "object" ? val.value : val;
			this.getDepartments(val.label);
		},
		selectedDepartment(val) {
			if (val === null || val === undefined) {
				return;
			}
			this.formatData.department = typeof val === "object" ? val.value : val;
			this.getCities(val.value);
		},
		hours(val) {
			if (val > 23) {
				this.hours = 23;
			}
		},
		minutes(val) {
			if (val > 59) {
				this.minutes = 59;
			}
		},
		"visitPoint.priority"(val) {
			if (val > 100) {
				this.visitPoint.priority = 100;
			}
		},
		activeTabProp(val) {
			if (val === 0) {
				this.checkboxPickup = true;
				this.checkboxDelivery = false;
				this.isDisabledDelivery = false;
				this.isDisabledPickup = true;
			} else {
				this.checkboxDelivery = true;
				this.checkboxPickup = false;
				this.isDisabledPickup = false;
				this.isDisabledDelivery = true;
			}
		},
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries.length <= 0) {
			this.$store
				.dispatch("moduleCommon/getCountries")
				.then((res) => {
					if (res.data.length === 1) {
						this.selectedCountry = res.data[0]["country_name"].toUpperCase();
					}
				})
				.catch((error) => {
					console.error(error);
				});
		}
		// Create Custom Validators
		Validator.extend("validatorEndHour", this.validatorEndHour);
		Validator.extend("validatorInitHour", this.validatorInitHour);
		Validator.extend("validatorInitDate", this.validatorInitDate);
		Validator.extend("validatorEndDate", this.validatorEndDate);
	},
};
